import React from 'react'
import parse from 'html-react-parser'
import Button from '@veneer/core/dist/esm/scripts/button'

/**
 * Parses an HTML string and replaces <button>[[ NameButton ]]</button> with React Button components,
 * using props from a map of button names to props.
 * @param {Object} params
 * @param {string} params.htmlString - The HTML string to parse.
 * @param {Array<{button: string, props: object}>} [params.buttonPropsMap=[]] - Array of objects with button HTML and props.
 * @returns {React.ReactNode|null}
 */
const renderButtonsInHtml = ({ htmlString, buttonsToParse = [] }) => {
  if (!htmlString) return null

  // NOTE: The extra escape characters are used to avoid issues with regex parsing
  // eslint-disable-next-line no-useless-escape
  const buttonNameRegex = /\[\[\s([^\]\[]+)\s\]\]/

  const buttonMap = buttonsToParse.reduce((acc, { button, props }) => {
    // Extract button key from the button HTML string
    // Regex to extract the button name from [[ NameButton ]]
    const match = button.match(buttonNameRegex)
    if (match && match[1]) {
      acc[match[1]] = props
    }
    return acc
  }, {})

  return parse(htmlString, {
    replace: (domNode) => {
      if (
        domNode.type === 'tag' &&
        domNode.name === 'button' &&
        domNode.children &&
        domNode.children.length === 1 &&
        domNode.children[0].type === 'text'
      ) {
        const match = domNode.children[0].data.match(buttonNameRegex)
        if (match && match[1] && buttonMap[match[1]]) {
          const buttonName = match[1]
          const props = buttonMap[buttonName] || {}
          return (
            <Button key={buttonName} {...props}>
              {props.buttonName || buttonName}
            </Button>
          )
        }
      }
      return undefined
    }
  })
}

export default renderButtonsInHtml
